<div class="banner">
  <div class="banner-text">
    <fa-icon [icon]="faIcon"></fa-icon>
    For more information on this new Research Protocol Catalog interface, <a href="https://mctools.sharepoint.com/:w:/t/CCS/IQC3rBZDDHgsSreZcxm_83-yAXJ-sJxHkUPtbTozypdmpr4" target="_blank">read the instructions</a>.
  </div>
</div>
